
import React from 'react';
import Layout from '@/components/Layout/Layout';
import PressureConverter from '@/components/UnitConverter/PressureConverter';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const PressureConverterPage = () => {
  return (
    <Layout>
      <div className="container mx-auto max-w-3xl px-4">
        <div className="mb-6">
          <Link to="/converters" className="flex items-center text-primary hover:underline mb-2">
            <ArrowLeft size={16} className="mr-1" />
            Back to All Converters
          </Link>
          <h1 className="text-3xl font-bold mb-2">Pressure Converter</h1>
          <p className="text-gray-600 mb-6">
            Convert between different units of pressure, from pascals to PSI and more.
          </p>
        </div>
        
        <div className="mb-8">
          <PressureConverter />
        </div>
        
        <div className="mt-10 prose max-w-none">
          <h2 className="text-xl font-semibold mb-4">About Pressure Converter</h2>
          <p>
            Our pressure converter tool allows you to convert between various pressure units 
            used in engineering, physics, meteorology, and everyday applications. Whether you need 
            to convert between metric units like pascals and bars, or imperial units like PSI, 
            our converter provides accurate results instantly.
          </p>
          
          <h3 className="text-lg font-medium mt-6 mb-2">Common Pressure Unit Conversions</h3>
          <p>
            Some of the most frequently used pressure conversions include:
          </p>
          <ul className="list-disc ml-6">
            <li>Converting between pascals and bars</li>
            <li>Converting PSI to bars (common in tire pressure)</li>
            <li>Converting atmospheres to other units</li>
            <li>Converting torr or mmHg (important in vacuum systems and medical contexts)</li>
          </ul>
          
          <h3 className="text-lg font-medium mt-6 mb-2">How to Use the Pressure Converter</h3>
          <p>
            Using our pressure converter is straightforward:
          </p>
          <ol className="list-decimal ml-6">
            <li>Enter the value you want to convert in the "From" field</li>
            <li>Select the pressure unit you're converting from</li>
            <li>Select the pressure unit you want to convert to</li>
            <li>The converted value will appear automatically</li>
          </ol>
          
          <p className="mt-6">
            The pressure converter supports a comprehensive range of units, including pascals (Pa), 
            kilopascals (kPa), megapascals (MPa), bars, psi, atmospheres (atm), torr, mmHg, and more. 
            Whether you're working in engineering, meteorology, or just checking tire pressure, 
            our converter provides accurate conversions between all common pressure units.
          </p>
        </div>
      </div>
    </Layout>
  );
};

export default PressureConverterPage;
